import ARCam from "./ARCam";

export default ARCam;
